import React from "react";
import { Container, Row, Col } from "reactstrap";

const WhyUsGrid = ({ data }) => {
    if (!data) return null;

    const { tagline, title, description, items, styles } = data;

    return (
        <section
            className="why_section"
            style={{
                background: styles?.background || "#fff",
                padding: "80px 0"
            }}
        >
            <Container>
                {/* Header */}
                <div className="sec-head text-center mb-5">
                    <p className="eyebrow">
                        {tagline}
                    </p>

                    <h2 className="mb-3" style={{ color: styles?.titleColor }}>
                        {title}
                    </h2>

                    <p className="mx-auto" style={{ maxWidth: "700px" }}>
                        {description}
                    </p>
                </div>

                {/* Cards */}
                <Row className="g-4 why-grid">
                    {items.map((item, index) => (
                        <Col md={6} lg={3} key={index}>
                            <div className="why-card h-100 p-4">

                                {/* Number */}
                                <div
                                    className="why-number"
                                    style={{ color: styles?.numberColor }}
                                >
                                    {item.number}
                                </div>

                                {/* Title */}
                                <h3 className="mt-2">{item.title}</h3>

                                {/* Description */}
                                <p className="mt-2">
                                    {item.description}
                                </p>

                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default WhyUsGrid;